import React, { useEffect, useState } from "react";
import { getURLparmas } from "../../utils";
import { fetchStoreInfo, getUserIcon, login, fetUserInfo } from "../../api/api";
import {
  fileUrl,
  gradeMap,
  gradeEnMap,
  operatorMap,
  operatorMapEn,
} from "../../const";
import addMorePng from "./../../asset/img/add-more.png";
import logoPng from "./../../asset/img/logo.png";
import styles from "./index.module.css";
import { LoadingOutlined } from "@ant-design/icons";

export const Operate = () => {
  const [userInfo, setUserInfo] = useState<any>(null);
  const [imgFile, setImgFile] = useState("");

  useEffect(() => {
    const userId = getURLparmas("userId");
    document.title = "INDIBA";
    if (!userId) return;
    // 获取数据，扫描二维码应该会携带参数，然后请求数据
    login({ username: "system", password: "qwert@12345!" }).then((res: any) => {
      if (res && res.code === 200) {
        localStorage.setItem("token", res.data);
        // 拿用户信息
        fetUserInfo(userId).then((resInfo: any) => {
          if (resInfo && resInfo.code === 200 && resInfo.data) {
            setUserInfo(resInfo.data);
            setImgFile(resInfo.data.F_HeadIcon);
          }
        });
      }
    });
  }, []);

  useEffect(() => {
    const height = document.getElementById("operate-content")?.offsetHeight;
    const operateRef = document.getElementById("operate-wrapper");
    if (height && operateRef) {
      operateRef.style.height = height + 238 + "px";
    }
  }, [userInfo]);

  if (!userInfo)
    return (
      <div className={styles.loading}>
        <LoadingOutlined />
      </div>
    );

  return (
    <div className={styles.wrapper} id="operate-wrapper">
      <div className={styles.header}>
        <div className={styles.logo}>
          <div className={styles.logoImgContainer}>
            <img className={styles.logoImg} src={logoPng} alt="logo" />
          </div>
        </div>
      </div>
      <div className={styles.content} id="operate-content">
        <div className={styles.personHeadContainer}>
          {/* <img className={styles.personImg} src={`${fileUrl}/${imgFile}`} alt='' /> */}
          <div className={styles.personImg}>
            <img src={`${fileUrl}/${imgFile}`} alt="" />
          </div>
        </div>
        <div className={styles.contentInfo}>
          <div className={styles.headInfo}>
            <div className={styles.name}>{userInfo.F_RealName}</div>
            <div className={styles.gradeZh}>{`${gradeMap[userInfo.F_Grade]}${
              operatorMap[userInfo.F_IsOperater]
            }`}</div>
            <div className={styles.gradeEh}>{`${gradeEnMap[userInfo.F_Grade]}${
              operatorMapEn[userInfo.F_IsOperater]
            }`}</div>
          </div>
          <div className={styles.contentRecord}>
            <div className={styles.recordItem}>
              <div className={styles.recordItemLeft}>
                <div>编号</div>
                <div>No</div>
              </div>
              <div>{userInfo.F_EnCode}</div>
            </div>
            <div className={styles.recordItem}>
              <div className={styles.recordItemLeft}>
                <div>认证日期</div>
                <div>Certification</div>
              </div>
              <div>{userInfo.F_CertificationDate}</div>
            </div>

            <div className={styles.recordItem}>
              <div className={styles.recordItemLeft}>
                <div>工作所在地</div>
                <div>Location</div>
              </div>
              <div>{userInfo.F_Address}</div>
            </div>
          </div>
          <div
            className={styles.footer}
            onClick={() => (window.location.href = "http://www.indibachn.com")}
          >
            <div>更多信息请点击查看官网</div>
            <div>More information click the official website</div>
            <img src={addMorePng} alt="more" />
          </div>
        </div>
      </div>
    </div>
  );
};
